import { render, staticRenderFns } from "./TempLogin.vue?vue&type=template&id=98824d42&scoped=true"
import script from "./TempLogin.vue?vue&type=script&lang=js"
export * from "./TempLogin.vue?vue&type=script&lang=js"
import style0 from "./TempLogin.vue?vue&type=style&index=0&id=98824d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98824d42",
  null
  
)

export default component.exports